import { createActions, handleActions } from 'redux-actions';

export const actionCreators = createActions({
    USER: {
        UPDATE: (parameters) => (parameters)
    }
});

const reducer = handleActions({
    USER: {
        UPDATE: (state, action) => {
            const { user } = action.payload
            return { ...state, user }
        },
    }
}, {
    user: undefined
});

export default reducer
